import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import { BiArrowBack } from "react-icons/bi";

import { getInvoiceDetail, incrementInvoicePrint, invoiceV2Selector } from "./invoiceV2Slice";
import { useDispatch, useSelector } from "react-redux";
import { Colors } from "../../../assets/Colors";
import { BlankoPOReturn } from "./CetakInvoice";

function fmtQty(n, mode) {
  const d = mode === "round" ? 0 : 4;
  return new Intl.NumberFormat("id-ID", { minimumFractionDigits: d, maximumFractionDigits: d }).format(Number(n) || 0);
}

// Cetak invoice V2 memakai format lama (BlankoPOReturn / react-pdf),
// disuapi data InvHeaderDetail V2 yang dipetakan ke bentuk yang dikenali layout lama.
export default function CetakInvoiceV2() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const invV2 = useSelector(invoiceV2Selector);

  // Bisa menerima invoice langsung (dari detail) atau hanya InvNo (lalu fetch)
  const passed = location.state?.invoice ?? null;
  const invNo = location.state?.InvNo ?? passed?.InvNo ?? null;
  const [inv, setInv] = useState(passed);
  const [revisi, setRevisi] = useState(null); // dari PrintCount (auto)
  const incrementedRef = useRef(false);

  useEffect(() => {
    if (!passed && invNo) dispatch(getInvoiceDetail(invNo));
  }, [passed, invNo]); // eslint-disable-line

  useEffect(() => {
    if (!passed && invV2.detail) setInv(invV2.detail);
  }, [passed, invV2.detail]);

  // Naikkan PrintCount sekali per buka halaman → jadi nomor Revisi otomatis
  useEffect(() => {
    if (invNo && !incrementedRef.current) {
      incrementedRef.current = true;
      dispatch(incrementInvoicePrint(invNo)).unwrap()
        .then((pc) => { if (pc != null) setRevisi(pc); })
        .catch(() => {});
    }
  }, [invNo]); // eslint-disable-line

  if (!invNo) {
    return (
      <div className="md:ml-64 flex items-center justify-center h-64 text-gray-400">
        <button onClick={() => navigate("/invoice-list-v2")} className="text-orange-500 underline">
          Kembali ke daftar invoice
        </button>
      </div>
    );
  }
  if (!inv) {
    return <div className="md:ml-64 flex items-center justify-center h-64 text-gray-400">Memuat invoice…</div>;
  }

  // Petakan InvHeaderDetail V2 → bentuk data yang dipakai format lama
  const data = {
    InvoiceNo: inv.InvNo,
    InvoiceDate: inv.InvoiceDate,
    DueDate: inv.DueDate,
    NamaKlien: inv.KlienName,
    CQ: inv.CQName,
    Alamat: inv.KlienAlamat,
    DPNumber: inv.DPNumber,
    Revisi: (revisi ?? inv.PrintCount) || "",
    NoKontrak: inv.NoKontrak,
    Contract: inv.QoNo,
    QuotationManual: inv.QoNo,
    Description: inv.Description || "Jasa/Pekerjaan sesuai Job Request",
    unit: "LS",
    Subtotal: inv.Subtotal,
    TaxPct: inv.TaxPct,
    TaxAmount: inv.TaxAmount,
    TotalAmount: inv.TotalAmount,
    Itemized: true,
    // Qty sudah diformat di sini sesuai opsi invoice (Desimal 4 angka / Pembulatan),
    // karena layout lama mencetak nilai Qty apa adanya.
    Detail: (inv.Lines && inv.Lines.length
      ? inv.Lines.map(l => ({ ...l, Qty: fmtQty(l.BilledQty, inv.QtyRounding) }))
      : [{ Amount: inv.Subtotal }]),
  };

  return (
    <div className="md:ml-64">
      <div className="px-3 md:px-8 py-3 flex items-center justify-between">
        <button onClick={() => navigate("/invoice-detail-v2", { state: { InvNo: inv.InvNo } })}
          className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900">
          <BiArrowBack className="text-lg" /> Kembali
        </button>
        <span className="text-sm font-semibold" style={{ color: Colors.primary }}>
          Cetak Invoice — {inv.InvNo}
        </span>
      </div>
      <div className="px-3 md:px-8" style={{ height: "calc(100vh - 56px)" }}>
        <PDFViewer className="w-full h-full" style={{ width: "100%", height: "100%" }}>
          <BlankoPOReturn data={data} NomorRekening={inv.BankAccount} />
        </PDFViewer>
      </div>
    </div>
  );
}
